import BaseStore from '@src/utils/store/base-store';
import DropDownMenuStore from './dropDownMenu/store';
import { observable } from 'mobx';
import { jumpPage } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import copy from '@src/components/copy';
import message from '@src/components/common-message';
import BGMStore from '../bgm/store';
import { useMount } from 'ahooks';
import styles from './index.less';
import debounce from 'lodash.debounce';
import { useEffect } from 'react';

export const NAVTYPE = {
  ANCHOR: 'anchor',
  Link: 'link',
  SELECT: 'select'
};

const linkMap = {
  '': 'index'
};

class NaviBarStore extends BaseStore {
  @observable
  bgm = new BGMStore({
    audioSrc: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749451035221_UPGRADE(D)_48k24b.mp3',
    musicIconRotate: false,
    localStoreNameSpace: 'mechabreak:bg-music'
  });

  dropDownMenuStore = new DropDownMenuStore();

  @observable isSticky = false;

  @observable navList = [];

  @observable navElem = null;

  /**
   * 跳转页面
   * @param link 路由链接
   * @param isHref 是否为外链
   * @param toast 点击提示
   */
  toPage = (link, isHref, toast) => {
    if (toast) {
      message.info(toast);
      return;
    }

    const htmlLink = linkMap[link] || link;
    if (isHref) {
      window.open(link);
    } else if (!IS_DEV_ENV) {
      const url = `${htmlLink}.html`;
      jumpPage(url, '#/');
    } else {
      this?.redirect('/' + link);
    }
  };

  @autobind
  listenScroll(e) {
    if (!this.navElem) {
      this.navElem = document.querySelector('.' + styles.navRoot);
    }
    const navTop = this.navElem.offsetTop;

    if (window.scrollY > navTop) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }

  @autobind
  onCopyLink() {
    copy(window.location.href);
  }

  @autobind
  setIsSticky(value) {
    this.isSticky = value;
  }

  use() {
    super.use();

    useMount(() => {
      this.navElem = document.querySelector('.' + styles.navRoot);
      window.document.addEventListener('scroll', debounce(this.listenScroll, 50));
      return () => {
        window.removeEventListener('scroll', this.listenScroll);
      };
    });
  }
}

export default NaviBarStore;
